import { IGraphDataPoint } from "../../../../shared/scripts/graphing/graphing.entities";
import { GetDateFromString } from "../../../../shared/scripts/date-functions";



export class FinancialForecastEntry {
    ID: string;
    Deliverable: string;
    Category: string;
    Unit_Desc: string;
    units_budgeted: number;
    Latest_Invoice: string;
    Billed_to_Date: number;
    cost_budgeted: number;
    Projection_Date: string;
    Projected_Spending: number;
    Within_Month_Proj_Spend: number;
    Within_Month_Proj_Units: number;
    Projected_Units: number;
    Overspending_Units: number;
    Overspending_Cost: number;
    source: string;
    isOverspent: boolean;
    Platform: string;
    IdSort: number;


    Billed_to_Date_Display: string;
    Projection_Date_Display: string;
    cost_budgeted_Display: string;
    Projected_Spending_Display: string;
    Within_Month_Proj_Spend_Display: string;
    Within_Month_Proj_Units_Display: string;
    Projected_Units_Display: string;
    Overspending_Cost_Display: string;
    AllPlatformsDisplay: string;
    CategorySort: number;
    units_budgeted_Display: string;
    Overspending_Units_Display: string
    Category_Display: string;
    isOverspent_Display: string;

    initialize(): void {
        this.Overspending_Cost = Math.round(this.Overspending_Cost);
        const result = this.ID.replace(/[a-zA-Z]/g, '');
        //this.IdSort = parseFloat(result);

        let projDate: Date = GetDateFromString(this.Projection_Date, "slash-month-day-year");
        this.IdSort = projDate.getTime();

        if (this.Projection_Date == null || this.Projection_Date == "" || this.Projection_Date == undefined) {
            this.Projection_Date_Display = "5/31/2026";
        }
        else {
            this.Projection_Date_Display = this.getMonth(this.Projection_Date);
        }

        this.Billed_to_Date_Display = this.displayCurrency(Math.round(this.Billed_to_Date));
        this.cost_budgeted_Display = this.displayCurrency(Math.round(this.cost_budgeted));
        this.Projected_Spending_Display = this.displayCurrency(Math.round(this.Projected_Spending));
        this.Within_Month_Proj_Spend_Display = this.displayCurrency(Math.round(this.Within_Month_Proj_Spend));
        this.Within_Month_Proj_Units_Display = this.displayUnits(this.Within_Month_Proj_Units);
        this.Projected_Units_Display = this.displayUnits(this.Projected_Units);
        this.Overspending_Cost_Display = this.displayCurrency(Math.round(this.Overspending_Cost));
        this.units_budgeted_Display = this.displayUnits(this.units_budgeted);
        this.Overspending_Units_Display = this.displayUnits(this.Overspending_Units);
        this.AllPlatformsDisplay = `<span style="cursor: pointer"><i class="fa-solid fa-arrow-up-right-from-square"></i>  ${this.Platform}</span>`;
        this.Category_Display = `<span style="cursor: pointer; text-decoration: underline; font-weight: bold;">${this.Category}</span>`;
        if (this.CategorySort != 1) {
            this.CategorySort = 2;
        }
        if (this.isOverspent) {
            this.isOverspent_Display = `<span><i class="fa-solid fa-xl fa-square-check"></i></span>`;
        }
        else {
            this.isOverspent_Display = `<span><i class="fa-solid fa-xl fa-square"></i></span>`;
        }
    }

    displayCurrency(amount: number) {
        let USDollar = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0, // No decimal places
            maximumFractionDigits: 0, // No decimal places
        });
        if (amount == null || amount == undefined) {
            return ""
        }
        else {
            return USDollar.format(amount);
        }
    }

    displayUnits(amount: number) {
        let numberFormatter = new Intl.NumberFormat('en-US', {
            style: 'decimal',
        });
        if (amount == null || amount == undefined) {
            return ""
        }
        else {
            return numberFormatter.format(amount);
        }
    }

    getMonth(dateString: string): string {
        const [month, day, year] = dateString.split('/').map(Number);

        if (!month || !day || !year) {
            throw new Error('Invalid date format');
        }

        const date = new Date(year, month - 1, day); // Month is 0-based in JS

        return new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(date);
    }


}

export class ForecastGraphDataPoint implements IGraphDataPoint {

    Count: number;
    TimeStamp: number;

    initialize(forecastItem: FinancialForecastEntry): void {

        this.Count = forecastItem.Projected_Spending;

        let projDate: Date = GetDateFromString(forecastItem.Projection_Date, "slash-month-day-year");
        this.TimeStamp = projDate.getTime();
    }

    getTimestamp(): number {
        return this.TimeStamp;
    }

    getCount(): number {
        return this.Count;

    }
}

export class BudgetDataPoint implements IGraphDataPoint {

    Count: number;

    TimeStamp: number;

    initialize(budget: number, date: string): void {

        this.Count = budget;

        let projDate: Date = GetDateFromString(date, "slash-month-day-year");
        this.TimeStamp = projDate.getTime();
    }

    getTimestamp(): number {
        return this.TimeStamp;
    }

    getCount(): number {
        return this.Count;

    }
}



export class ForecastGraphData {
    DrillDown: ForecastGraphData[];

    name: string;


    budget: number;
    forecastProj: number;
    forecastTrend: number;

    initialize(): void {

    }

}